type HTMLEventHandler = (e: Event) => void;
/**
* Tableau Event handler needs this data to properly remove event listeners.
*/
class DomSubscriptionHandle {
  public readonly DomElement: HTMLElement;
  public readonly EventHandler: HTMLEventHandler;

  public constructor(domElement: HTMLElement, eventHandler: HTMLEventHandler) {
    this.DomElement = domElement;
    this.EventHandler = eventHandler;
  }
}

export { HTMLEventHandler, DomSubscriptionHandle };
